import { render } from "./CalculatorView.vue?vue&type=template&id=950bfa78&scoped=true"
import script from "./CalculatorView.vue?vue&type=script&lang=js"
export * from "./CalculatorView.vue?vue&type=script&lang=js"

import "./CalculatorView.vue?vue&type=style&index=0&id=950bfa78&scoped=true&lang=css"

import exportComponent from "C:\\llx\\1-it\\mahjong-vue-PWA-PR\\mahjong-vue-PWA-PR\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-950bfa78"]])

export default __exports__